<template>
  <div>

    <b-col cols="12">
      <b-card-code>
        <b-card-title>Latest Activity</b-card-title>
        <div
          ref="scrollContainer"
          class="log-scrollable"
          @scroll="handleScroll"
        >
          <b-card>
            <app-timeline>
              <app-timeline-item
                v-for="(log, index) in activityLog"
                :key="index"
                variant="primary"
              >
                <div
                  class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
                >
                  <span class="cursor-pointer" @click="generateUrl(log)" v-html="log?.data?.message" />

                  <small class="text-muted">{{
                    formatDateTime(log?.created_at)
                  }}</small>
                </div>
              </app-timeline-item>

              <div
                v-if="loading"
                class="text-center my-2"
              >
                <b-spinner
                  small
                  label="Loading..."
                />
              </div>

            </app-timeline>
          </b-card>
        </div>
      </b-card-code>
    </b-col>

  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BButtonToolbar,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormSelect,
  BLink,
  BListGroup,
  BListGroupItem,
  BModal,
  BPagination,
  BRow,
  BSpinner, BTab, BTabs,
  VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import {
  MILESTONE_BOARD_CREATE,
  MILESTONE_BOARD_DELETE,
  MILESTONE_BOARD_EDIT,
  MILESTONE_BOARD_SEE_ALL,
  MILESTONE_BOARD_UPDATE_STATUS,
} from '@/helpers/permissionsConstant'
import LvColorPicker from 'lightvue/color-picker'
import { milestoneTaskBoardStatusConstants } from '@/helpers/constant/milestoneTaskBoardStatusConstant.js'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import flatPickr from 'vue-flatpickr-component'
import {
  milestoneBoardTypeConstants as milestoneBoardTypeConstant,
} from '@/helpers/constant/milestoneBoardTypeConstant.js'
import UserSelect from '@/layouts/components/UserSelect.vue'
import UserCard from '@/layouts/components/UserCard.vue'
import { formatDateRange } from '@/helpers/helpers'
import {
  required, max, size, ext, max_value, min_value,
} from '@validations'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import BCardCode from '@core/components/b-card-code'
import { priorityOptionConstants } from '@/helpers/constant/priorityOptionConstant'

export default {
  name: 'DashboardActivityLog',
  components: {
    BTabs,
    BCardCode,
    BTab,
    AppTimeline,
    AppTimelineItem,
    UserCard,
    UserSelect,
    LvColorPicker,
    BForm,
    BRow,
    BCol,
    BButton,
    BButtonGroup,
    BButtonToolbar,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BBadge,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BLink,
    BListGroup,
    BListGroupItem,
    BFormDatepicker,
    BFormRadio,
    BFormCheckbox,
    flatPickr,
    BCardActions,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },

  data() {
    return {

      priorityOptionConstants,

      activityLog: [],

      currentPage: 1,
      perPage: 5,
      lastPage: false,
      loading: false,

    }
  },
  computed: {
  },

  mounted() {
    this.loadActivityLog()
  },

  methods: {

    generateUrl(notification) {
      if (notification?.data?.url) {
        const currentPageURL = window.location.href;
        const baseUrl = new URL(currentPageURL).origin;
        const notificationUrl = notification?.data?.url;
        const routeUrl = `${baseUrl}/${notificationUrl}`
        window.open(routeUrl, "_blank")
      }
    },

    handleScroll(event) {
      const scrollContainer = event.target
      const bottomReached = scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 10
      if (bottomReached && !this.loading) {
        this.loadActivityLog() // Load more when bottom is reached
      }
    },

    async loadActivityLog() {
      if (this.loading || this.lastPage) return

      this.loading = true
      try {
        const response = await this.$api.get('api/outreach/activity-log', {
          params: {
            page: this.currentPage,
            per_page: this.perPage,
          },
        })

        const { data, meta } = response.data

        this.activityLog.push(...data)
        this.currentPage++

        if (this.currentPage > meta.last_page) {
          this.lastPage = true
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error loading activity log',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: error?.response?.data?.message ?? error.message,
          },
        })
      } finally {
        this.loading = false
      }
    },
    formatDateTime(value) {
      if (value) {
        return this.$moment(value).format('MMM Do YY, h:mm:ss a')
      }
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/pages/ui-feather.scss";

.table-custom-style {
  font-size: 13px !important;
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    //vertical-align: middle !important;
    text-align: left !important;
  }
}
.table-cell-margin {
  margin: 8px 0px;
}
.second-layer-margin {
  margin-top: 15px;
}

.required-label label::after {
  content: " *";
  color: red;
}

.log-scrollable {
  min-height: 50vh;
  max-height: 50vh;
  overflow-y: scroll;
}
</style>
